import React from 'react';
import { NamedLink } from '../../components';
import IconCart from './IconCart';
import css from './CartLink.module.css';

const CartLink = ({ currentUser }) => {
  const currentCart = currentUser?.attributes?.profile?.publicData?.cart || [];
  const count = currentCart.length;
  return (
    <NamedLink className={css.cartLink} name="CartPage">
      <div className={css.cartIcon}>
        <IconCart />
        {count > 0 ? <span className={css.cartCounter}>{count}</span> : null}
      </div>
    </NamedLink>
  );
};

export default CartLink;
